function prepareName(data) {
  const localData = data;
  const names = getNames(data);
  if (!names.length) {
    return;
  }
  localData.name = names.join(' ');
  localData.firstname = localData.firstname ? localData.firstname.trim() : localData.firstname;
  localData.lastname = localData.lastname ? localData.lastname.trim() : localData.lastname;
}

function getNames(data) {
  const names = [];
  if (data.firstname) {
    names.push(data.firstname.trim());
  }
  if (data.lastname) {
    names.push(data.lastname.trim());
  }
  return names.filter(name => !!name);
}

module.exports = { prepareName };
